import React, { useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import { GradientButton } from '../common/Buttons';
import { WhiteBorderButton } from '../common/Buttons/V2';
import { Text, Bold, Red } from '../common/Text';
import Flex from '../common/Flex';

interface Props {
  action?: string;
  name?: string;
  callback?: (() => Promise<void>) | (() => void);
  redirect?: string | false;
  message?: string;
  style?: React.CSSProperties;
  noRedirectCb?: () => void;
  close?: () => void;
}

const Confirm = ({
  action,
  name,
  callback,
  redirect,
  message,
  style,
  noRedirectCb,
  close,
}: Props) => {
  const { t } = useTranslation('modals');
  const router = useRouter();
  const [confirm, setConfirm] = useState(false);
  const handler = async () => {
    if (callback) {
      await callback();
    }
    if (noRedirectCb && !redirect) noRedirectCb();
    setConfirm(true);
  };

  if (redirect && confirm) {
    router.push(redirect);
  }

  return (
    <Container style={style}>
      <Text>
        {message ? (
          <Bold>{message}</Bold>
        ) : (
          <Bold>
            {t('modals:doYouReally')} {action} <Red>{name}</Red>
          </Bold>
        )}
      </Text>
      <Flex>
        <GradientButton onClick={handler}>
          {message ? t('modals:confirm') : t('modals:yes')}
        </GradientButton>
        {close && (
          <WhiteBorderButton onClick={close} style={{ marginLeft: 16 }}>
            {t('modals:cancel')}
          </WhiteBorderButton>
        )}
      </Flex>
    </Container>
  );
};

export default Confirm;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding-right: 30px;
  ${Text} {
    font-size: 24px;
    text-align: center;
  }
`;
